import { money } from "@/lib/api";
import { AlertTriangle, MapPin, Truck } from "lucide-react";

export function ShippingQuote({ q, confirmed, onConfirm }) {
  if (!q) return <p className="text-sm text-muted-foreground" data-testid="ship-quote-loading">Calculating shipping…</p>;
  return (
    <div className="space-y-3" data-testid="ship-quote">
      {q.status === "needs_address" ? (
        <div className="rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm" data-testid="ship-confirm-island">
          <p className="font-semibold flex items-center gap-2"><AlertTriangle size={16} className="text-amber-600" /> {q.notes[0]}</p>
          <div className="flex gap-3 mt-3">
            {["north", "south"].map((i) => (
              <label key={i} className="flex items-center gap-2"><input type="radio" name="island" checked={confirmed === i} onChange={() => onConfirm(i)} data-testid={`ship-island-${i}`} /> {i === "north" ? "North Island" : "South Island"}</label>
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap gap-2 text-xs" data-testid="ship-region">
            <span className="px-2 py-1 rounded-full bg-steel text-white flex items-center gap-1"><MapPin size={12} /> {q.zone || `${q.island === "north" ? "North" : "South"} Island`}</span>
            {q.rural && <span className="px-2 py-1 rounded-full bg-amber-100 text-amber-800" data-testid="ship-rural">Rural delivery</span>}
            {q.status === "quote_pending" && <span className="px-2 py-1 rounded-full bg-red-100 text-red-700" data-testid="ship-quote-pending">Freight quote required</span>}
            {q.free_shipping && q.status === "final" && <span className="px-2 py-1 rounded-full bg-emerald-100 text-emerald-700">FREE shipping</span>}
          </div>
          <div className="rounded-xl border-2 border-accent/50 bg-amber-50/50 p-4 text-sm">
            <div className="font-semibold flex items-center gap-2" data-testid="ship-method"><Truck size={16} /> {q.method}</div>
            <div className="mt-2 space-y-1">
              {q.breakdown.map((b, i) => (
                <div key={i} className="flex justify-between"><span className="text-muted-foreground">{b.label}</span>
                  <span className="font-mono">{b.pending ? "Quote pending" : b.amount === 0 ? "FREE" : money(b.amount)}</span></div>
              ))}
            </div>
          </div>
          {q.notes.map((n, i) => <p key={i} className="text-xs text-muted-foreground" data-testid={`ship-note-${i}`}>{n}</p>)}
        </>
      )}
    </div>
  );
}
